import FeedSearch from './FeedSearch';

export default FeedSearch;
